<template>
  <div>
    <b-card>
      <div style="display: flex; flex-direction: row; min-height: 250px">
        <div style="width: 50%; padding-right: 3vw;">
          <b-card-title>
            {{$t('information')}}
          </b-card-title>
          <table class="mt-7 mt-xl-0 w-100">
            <tr>
              <th class="pb-50">
                <span class="font-weight-bold">{{$t('birth_date')}}</span>
              </th>
              <td class="pb-50 text-right">
                {{ userData.birthday }}
              </td>
            </tr>
            <tr>
              <th class="pb-50">
                <span class="font-weight-bold">{{$t('address')}}</span>
              </th>
              <td class="pb-50 text-capitalize text-right">
                {{ getAddress(userData.address) }}
              </td>
            </tr>
            <tr v-if="appConfig.type === 'hw-admin'">
              <th class="pb-50">
                <span class="font-weight-bold">{{$t('applicationText')}}</span>
              </th>
              <td class="pb-50 text-right">
                <b-link
                  :to="{
                    name: 'apps-applications-view',
                    params: { id: $router.currentRoute.params.id },
                  }"
                >
                  {{$t('applicationText')}}
                </b-link>
              </td>
            </tr>
            <tr v-if="appConfig.type === 'hw-admin'">
              <th class="pb-50 text-capitalize">
                <span class="font-weight-bold">{{$t('permits')}}</span>
              </th>
              <td class="pb-50 text-capitalize text-right">
                {{ userData.permits ? userData.permits.join(', ') : '' }}
              </td>
            </tr>
            <tr>
              <th class="pb-50">
                <span class="font-weight-bold">{{$t('finnish')}}</span>
              </th>
              <td class="pb-50 text-capitalize text-right">
                {{ userData.finnish }}
              </td>
            </tr>
            <tr>
              <th class="pb-50">
                <span class="font-weight-bold">{{$t('languages')}}</span>
              </th>
              <td class="pb-50 text-capitalize text-right">
                {{ userData.languages ? userData.languages.join(', ') : '' }}
              </td>
            </tr>
          </table>
        </div>
        <!-- <div style="width: 50%;">
          <b-card-title>
            {{ $t("additional_information") }}
          </b-card-title>
          <table class="mt-7 mt-xl-0 w-100">
            <tr>
              <th class="pb-50">
                <span class="font-weight-bold">{{$t("bestTimeToContact")}}</span>
              </th>
              <td class="pb-50 text-right">
                {{ userData.application.bestTimeToReach ? $t(userData.application.bestTimeToReach) : '-' }}
              </td>
            </tr>
            <tr>
              <th class="pb-50">
                <span class="font-weight-bold">{{$t("employmentStatus")}}</span>
              </th>
              <td class="pb-50 text-capitalize text-right">
                {{ userData.application.employmentStatus ? $t(userData.application.employmentStatus) : '-'}}
              </td>
            </tr>
            <tr v-if="appConfig.type === 'hw-admin'">
              <th class="pb-50">
                <span class="font-weight-bold">{{$t("distanceFromHome")}}</span>
              </th>
              <td class="pb-50 text-right">
                {{ userData.application.radius ? userData.application.radius : '-'}}
              </td>
            </tr>
            <tr v-if="appConfig.type === 'hw-admin'">
              <th>
                <span class="font-weight-bold">{{$t("workType")}}</span>
              </th>
              <td class="pb-50 text-capitalize text-right">
                {{ seeking ? seeking.join(', ') : ''}}
              </td>
            </tr>
            <tr v-if="appConfig.type === 'hw-admin'">
              <th class="pb-50 text-capitalize">
                <span class="font-weight-bold">{{$t("preferredWorkTime")}}</span>
              </th>
              <td class="pb-50 text-capitalize text-right">
                {{ workTimePreferences ? workTimePreferences.join(', ') : '-'}}
              </td>
            </tr>
            <tr>
              <th class="pb-50">
                <span class="font-weight-bold">{{$t("preferredWorkplace")}}</span>
              </th>
              <td class="pb-50 text-capitalize text-right">
                {{ workplacePreferences ? workplacePreferences.join(', ') : '' }}
              </td>
            </tr>
          </table>
        </div> -->
      </div>
      <div style="display: flex; flex-direction: row; justify-content: space-between;">
        <b-button
          variant="outline-primary"
          class="mt-1"
          :disabled="isSendingReset"
          style="width: 15%;"
          @click="sendEmailResetPassword"
        >
          {{$t('reset_password')}}
          <b-spinner
            v-if="isSendingReset"
            style="width: 15px; height: 15px;"
          />
        </b-button>
        <b-button
          v-b-modal.send-message-modal
          variant="outline-primary"
          class="mt-1"
          style="width: 15%;"
        >
          {{ $t('personel.btn.sendEmail') }}
        </b-button>
        <b-button
          v-b-modal.send-sms-modal
          variant="outline-primary"
          class="mt-1"
          style="width: 15%;"
        >
          {{ $t('personel.btn.sendSMS') }}
        </b-button>
        <b-button
          v-if="appConfig.type === 'hw-admin'"
          variant="outline-primary"
          class="mt-1"
          style="display: flex; flex-direction: row; width: 15%;"
          :disabled="isSendingTuberculosisSurvey"
          @click="sendTuberculosisSurvey"
        >
          Lähetä tuberkuloosikysely
          <b-spinner
            v-if="isSendingTuberculosisSurvey"
            style="width: 15px; height: 15px;"
          />
        </b-button>
        <b-button
          v-b-modal.temporary-contract-modal
          variant="outline-primary"
          class="mt-1"
          style="width: 15%;"
        >
          {{ $t('personel.btn.createTemporaryContract') }}
        </b-button>
        <b-button
          variant="outline-primary"
          class="mt-1"
          style="width: 15%;"
          @click="createTestimonial"
        >
          Luo työtodistus
        </b-button>
      </div>
    </b-card>
    <send-message-modal :user-data="userData" @send-message="onCreateZendeskTicket" />

    <send-SMS-modal :user-data="userData" @send-sms="sendSMS" />

    <temporary-contract-modal :user-data="userData" @create-temp-contract="createTempContract" />

    <testimonial-modal :user-data="userData" @create-testimonial="createTestimonial" />
  </div>
</template>

<script>
import { BCard, BCardTitle, BButton, BLink, BSpinner } from 'bootstrap-vue'
import store from '@/shared/store'
import ToastificationContent from '@hw-ui/components/toastification/ToastificationContent.vue'
import { functions, auth, db } from '@/shared/services/firebase'
import axios from 'axios'
import html2pdf from 'html2pdf.js'
import SendMessageModal from './SendMessageModal.vue'
import SendSMSModal from './SendSMSModal.vue'
import TemporaryContractModal from './TemporaryContractModal.vue'
import TestimonialModal from './TestimonialModal.vue'

export default {
  components: {
    BCard,
    BCardTitle,
    BButton,
    BLink,
    SendMessageModal,
    SendSMSModal,
    TemporaryContractModal,
    TestimonialModal,
    BSpinner,
  },
  props: {
    userData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isSendingWelcome: false,
      isSendingReset: false,
      isSendingTuberculosisSurvey: false,
      processer: {},
      documentRequestTemplate: 'P016OA4TW0WqDs5BxcKV',
      /* workTimePreferences: null,
      workplacePreferences: null, */
      seeking: null,
    }
  },
  computed: {
    appConfig() {
      return this.$store.state.app.appConfig || {}
    },
  },
  beforeCreate() {
    this.$store.dispatch('appAuth/getCurrentUser').then(res => {
      const user = JSON.parse(JSON.stringify(res))
      this.processer = {
        firstName: user.firstName,
        lastName: user.lastName,
        email: user.email,
      }
    })
  },
  /* created() {
    const translatedWorkTimeData = []
    // eslint-disable-next-line no-restricted-syntax
    for (const item of this.userData.application.workTimePreferences) {
      translatedWorkTimeData.push(this.$t(item))
    }
    this.workTimePreferences = translatedWorkTimeData

    const translatedWorkPlaceData = []
    // eslint-disable-next-line no-restricted-syntax
    for (const item of this.userData.application.workplacePreferences) {
      translatedWorkPlaceData.push(this.$t(item))
    }
    this.workplacePreferences = translatedWorkPlaceData

    const translatedSeekingData = []
    // eslint-disable-next-line no-restricted-syntax
    for ( const item of this.userData.application.seeking) {
      translatedSeekingData.push(this.$t(item))
    }
    this.seeking = translatedSeekingData
  }, */
  methods: {
    async createTestimonial() {
      const shiftsCollection = await db
        .collection('shifts')
        .where('assignedTo', '==', this.userData.id)
        .where('status', '==', 'confirmed')
        .get()
      const shiftsTotal = shiftsCollection.size
      const hoursTotal = Number(shiftsCollection.docs.reduce((accumulator, currentValue) => accumulator + (currentValue.data().end.toDate().getTime() - currentValue.data().start.toDate().getTime()) / 3600000, 0)).toFixed(0)
      const areaIds = [...new Set(shiftsCollection.docs.reduce((accumulator, currentValue) => [...accumulator, currentValue.data().areaId], []))]
      const areas = await Promise.all(areaIds.map(async id => {
        const areaDoc = await db.collection('areas').doc(id).get()
        return areaDoc.data().name
      }))
      const element = `
        <img
          src="https://firebasestorage.googleapis.com/v0/b/hoiwa-app.appspot.com/o/hoiwa%2Flogos%2Fhoiwa_logo.png?alt=media&token=35aa6c1a-3696-4040-95ec-ba5007d5be0e"
          style="width: 100px; height: 100px;"
        >
        <br>
        <h4>Hoiwa Oy</h4>
        <p>Y-tunnus: 3122829-4</p>
        <p>Bertel Jungin aukio 5</p>
        <p>02600 Espoo</p>
        <br>
        <br>
        <h3>TYÖTODISTUS</h3>
        <p>${this.userData.firstName.slice(0, 1).toUpperCase()}${this.userData.firstName.slice(1).toLowerCase()} ${this.userData.lastName.slice(0, 1).toUpperCase()}${this.userData.lastName.slice(1).toLowerCase()} on työskennellyt Hoiwa Oy:llä vaihtelevan työajan sopimuksella 0-37,5 tuntia viikossa.</p>
        <p>Työsuhde alkoi: ${this.userData.created.toDate().toLocaleDateString('fi-FI')}</p>
        <p>Suoritettuja vuoroja yhteensä: ${shiftsTotal}</p>
        <p>Tunnit yhteensä: ${hoursTotal}</p>
        <p>Työskennellyt seuraavissa toimipisteissä:</p>
        ${areas.map(area => `<li>- ${area.slice(0, 1).toUpperCase()}${area.slice(1)}</li>`)}
        <br>
        <br>
        <p>Espoossa ${new Date().toLocaleDateString('fi-FI')}</p>
        <p>Jama Ali</p>
        <p>HR-koordinaattori / Hoiwa Oy</p>
      `
      await html2pdf().set({ margin: 20 }).from(element).save(`Työtodistus ${this.userData.firstName.slice(0, 1).toUpperCase()}${this.userData.firstName.slice(1).toLowerCase()} ${this.userData.lastName.slice(0, 1).toUpperCase()}${this.userData.lastName.slice(1).toLowerCase()}.pdf`)
    },
    getAddress(address) {
      let str = ''
      str = `${address.streetAddress}, ${address.postcode} ${address.city}, ${address.state}`
      return str
    },
    sendEmailResetPassword() {
      this.isSendingReset = true
      store
        .dispatch('appPersonel/sendEmailReset', { email: this.userData.email })
        .then(() => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$t('success'),
              icon: 'CheckIcon',
              text: 'Salasanan nollaussähköposti lähetetty',
              variant: 'success',
            },
          })
          this.isSendingReset = false
        })
        .catch(() => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$t('error'),
              text: this.$t('something_went_wrong'),
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
          this.isSendingReset = false
        })
    },

    async onCreateZendeskTicket({ to, subject, message }) {
      await store.dispatch('appPersonel/createZendeskTicket', {
        requester: this.processer.email,
        groupId: '360007929138',
        message,
        collaborators: [to],
        subject,
      })
      this.$toast({
        component: ToastificationContent,
        props: {
          title: this.$t('success'),
          icon: 'CheckIcon',
          text: 'Sähköposti lähetetty',
          variant: 'success',
        },
      })
    },

    sendSMS({ body }) {
      const { mobile } = this.userData
      store
        .dispatch('appPersonel/sendSMS', {
          mobile: this.formatMobile(mobile),
          message: body,
        })
        .then(() => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$t('success'),
              text: 'Tekstiviesti lähetetty',
              icon: 'CheckIcon',
              variant: 'success',
            },
          })
        })
        .catch(() => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$t('error'),
              text: this.$t('something_went_wrong'),
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        })
    },

    formatMobile(mobile) {
      if (mobile.charAt(0) === '0') {
        return `+358${mobile.substring(1)}`
      }
      if (mobile.charAt(0) !== '+') {
        return `+358${mobile}`
      }

      return mobile
    },
    async createTempContract(newTempContract, locationText, salaryText) {
      const { typeContract } = newTempContract

      const toastId = this.$toast(
        {
          component: ToastificationContent,
          props: {
            title: this.$t('personel.temp_contract.modal.notification.willUpdate'),
            icon: 'UserIcon',
            variant: 'info',
          },
        },
        { timeout: 0 }
      )

      try {
        if (typeContract === 'new_contract') {
          const startDateStr = newTempContract.startDate.toString()
          const endDateStr = newTempContract.endDate.toString()
          const idToken = await auth.currentUser.getIdToken(true)
          const newTempContRes = await axios.post(`${functions.url}/createTempUserContract`, {
            user: this.userData,
            token: idToken,
            startDate: startDateStr,
            endDate: endDateStr,
            locationText,
            salaryText,
            hours: newTempContract.hours,
          })
          const { id } = newTempContRes.data

          // eslint-disable-next-line no-param-reassign
          newTempContract.workContract.documentUuid = id
          await axios.post(`${functions.url}/publishContract`, { contractID: id, token: idToken })
        }

        let tempContract = [...(this.userData.tempContract ? this.userData.tempContract : [])]
        tempContract.push(newTempContract)
        tempContract = tempContract.map(item => ({
          accountId: item.accountId,
          areaId: item.areaId,
          contractId: item.contractId,
          endDate: item.endDate,
          processer: item.processer,
          startDate: item.startDate,
          workContract: item.workContract,
          bonus: item.bonus === undefined ? {} : item.bonus,
          hours: item.hours || null,
        }))

        // Update user
        await store.dispatch('appPersonel/updateUser', {
          id: this.userData.uid,
          data: { tempContract },
        })
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$t('success'),
            text: 'Käyttäjä päivitetty',
            icon: 'CheckIcon',
            variant: 'success',
          },
        })
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$t('error'),
            text: this.$t('something_went_wrong'),
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      } finally {
        this.$toast.dismiss(toastId)
        this.$router.go()
      }
    },
    async sendTuberculosisSurvey() {
      this.isSendingTuberculosisSurvey = true
      store
        .dispatch('appPersonel/sendTuberculosisSurvey', { id: this.userData.id })
        .then(() => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$t('success'),
              icon: 'CheckIcon',
              text: 'Tuberkuloosikysely lähetetty',
              variant: 'success',
            },
          })
          this.isSendingTuberculosisSurvey = false
        })
        .catch(() => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$t('error'),
              text: this.$t('something_went_wrong'),
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
          this.isSendingTuberculosisSurvey = false
        })
    },
  },
}
</script>
<style>
.translateY-20 {
  transform: translateY(20px);
}
.text-right {
  text-align: center;
}
</style>